import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import ProtectedRoute from '../components/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AppointmentsPage = lazy(() => import('../pages/admin/appointments/page'));
const LeadsPage = lazy(() => import('../pages/admin/leads/page'));
const TreatmentsPage = lazy(() => import('../pages/admin/treatments/page'));
const ClientesPage = lazy(() => import('../pages/admin/clientes/page'));
const VideosPage = lazy(() => import('../pages/admin/videos/page'));
const ReportsPage = lazy(() => import('../pages/admin/reports/page'));
const FinanceiroPage = lazy(() => import('../pages/admin/financeiro/page'));
const UsersPage = lazy(() => import('../pages/admin/users/page'));
const PerfilPage = lazy(() => import('../pages/admin/perfil/page'));
const MinhaAgendaPage = lazy(() => import('../pages/admin/minha-agenda/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/admin/dashboard',
    element: <ProtectedRoute><DashboardPage /></ProtectedRoute>
  },
  {
    path: '/admin/appointments',
    element: <ProtectedRoute><AppointmentsPage /></ProtectedRoute>
  },
  {
    path: '/admin/leads',
    element: <ProtectedRoute><LeadsPage /></ProtectedRoute>
  },
  {
    path: '/admin/treatments',
    element: <ProtectedRoute><TreatmentsPage /></ProtectedRoute>
  },
  {
    path: '/admin/clientes',
    element: <ProtectedRoute><ClientesPage /></ProtectedRoute>
  },
  {
    path: '/admin/videos',
    element: <ProtectedRoute requiredRole="admin"><VideosPage /></ProtectedRoute>
  },
  {
    path: '/admin/reports',
    element: <ProtectedRoute requiredRole="admin"><ReportsPage /></ProtectedRoute>
  },
  {
    path: '/admin/financeiro',
    element: <ProtectedRoute requiredRole="admin"><FinanceiroPage /></ProtectedRoute>
  },
  {
    path: '/admin/usuarios',
    element: <ProtectedRoute requiredSuperAdmin><UsersPage /></ProtectedRoute>
  },
  {
    path: '/admin/perfil',
    element: <ProtectedRoute><PerfilPage /></ProtectedRoute>
  },
  {
    path: '/admin/minha-agenda',
    element: (
      <ProtectedRoute>
        <MinhaAgendaPage />
      </ProtectedRoute>
    )
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;